import axios from "axios";
const instance = axios.create({
    baseURL: "https://trackingservice.studioexpress.de:5000",
});

export default instance;
